// JHK color code map (color NAME in UPPERCASE -> official 2-3 letter symbol)
export const COLOR_CODES = {
  WHITE: "WH", BLACK: "BK", RED: "RD", BROWN: "BR", CHOCOLATE: "CH", NAVY: "NY",
  BURGUNDY: "BU", "ROYAL BLUE": "RB", DENIM: "DN", "AMAZONIA GREEN": "AG",
  LAVENDER: "LV", LAVANDER: "LV", "FOREST GREEN": "FG", GRAPHITE: "GF", FUCSIA: "FU",
  FUCHSIA: "FU", "LIME STONE": "LS", ARMY: "AR", "ASH MELANGE": "AS", ORANGE: "OR",
  "LIGHT YELLOW": "LY", AZZURE: "AZ", AZURE: "AZ", "GREY MELANGE": "GM", "GRAY MELANGE": "GM",
  "PALE GREEN": "PG", PEACH: "PH", "ICE BLUE": "IB", AZALEA: "AL", "PINK VINTAGE": "PV",
  ZINC: "ZC", TURQUOISE: "TU", CARDINAL: "CA", "WARM RED": "WR", "TROPICAL GREEN": "TP",
  "KELLY GREEN": "KG", "BOTTLE GREEN": "BG", PISTACHIO: "PT", PFD: "PFD", "MOSS GREEN": "MO",
  PURPLE: "PU", MUSTARD: "MU", "MINT GREEN": "MG", KHAKI: "KH", RASPBERRY: "RP",
  "STEEL BLUE": "SB", LIME: "LM", SILVER: "SL", "SKY BLUE": "SK", "BUTTER CREAM": "BT",
  BUTTERCREAM: "BT", "CANARY RED": "CR", TANGERINE: "TG", "PETROL BLUE": "PB",
  AQUAMARINE: "AQM", OCHER: "OC", OCHRE: "OC", TEAL: "TE", "ANCIENT PINK": "AN",
  IVORY: "IV", YELLOW: "YW", AQUA: "AQ", GOLD: "GO", SAND: "SA", PINK: "PK",
  "DUSTY PURPLE": "DP", BRICK: "BC", "ASH GREY": "AY", "ASH GRAY": "AY",
  CORAL: "CO", VIOLET: "VI", APPLE: "AP", "KLEIN BLUE": "KB", "PINK GUM": "PKG",
  "MEXICAN GREEN": "MXG", "WOLF GREY": "WG", "SPRING GREEN": "SG", ALOE: "AE",
  "LEMON YELLOW": "LEY", ORCHID: "OD", APRICOT: "APR", "LIGHT PURPLE": "LP",
  "BROWN DARK": "BRD", CHARCOAL: "CHC", "CHARCOAL HEATHER": "CHCH", "DENIM HEATHER": "DNH",
  "DARK GREY MELANGE": "DGM", "FUCSIA FLUOR": "FUF", "LIME FLUOR": "LMF",
  "ORANGE FLUOR": "ORF", "GOLD FLUOR": "SYF",
};

const key = (name) => String(name || "").trim().toUpperCase();

// Approx. hex per color name (JHK + common non-JHK) for swatch preview.
export const COLOR_HEX = {
  WHITE: "#FFFFFF", BLACK: "#1A1A1A", RED: "#C8102E", BROWN: "#5A3A29", CHOCOLATE: "#3F2A20",
  NAVY: "#1F2A44", BURGUNDY: "#6B1F2E", "ROYAL BLUE": "#1E56A0", DENIM: "#4A6A8A",
  "AMAZONIA GREEN": "#1E7A5A", LAVENDER: "#B9A7D6", LAVANDER: "#B9A7D6", "FOREST GREEN": "#1F4D2E",
  GRAPHITE: "#3A3F44", FUCSIA: "#C42A82", FUCHSIA: "#C42A82", "LIME STONE": "#D9D2B0", ARMY: "#5A5A3A",
  "ASH MELANGE": "#C9CBCE", ORANGE: "#F26522", "LIGHT YELLOW": "#F7E8A0", AZZURE: "#6FA8DC", AZURE: "#6FA8DC",
  "GREY MELANGE": "#9AA0A6", "GRAY MELANGE": "#9AA0A6", "PALE GREEN": "#BFD8AE", PEACH: "#F6C1A0",
  "ICE BLUE": "#CFE3EE", AZALEA: "#E7A6C4", "PINK VINTAGE": "#D69AA6", ZINC: "#7C8388", TURQUOISE: "#1BA6A6",
  CARDINAL: "#8C1D2C", "WARM RED": "#E23B2E", "TROPICAL GREEN": "#2E8B57", "KELLY GREEN": "#2E9B47",
  "BOTTLE GREEN": "#14452F", PISTACHIO: "#A6C48A", PFD: "#F2EFE6", "MOSS GREEN": "#6B7A3A", PURPLE: "#5E3A8C",
  MUSTARD: "#C99A2E", "MINT GREEN": "#A8D8C0", KHAKI: "#8F8459", RASPBERRY: "#A5264B", "STEEL BLUE": "#4A6E8A",
  LIME: "#9CCB3B", SILVER: "#C7CACC", "SKY BLUE": "#7FB6E0", "BUTTER CREAM": "#F2E6B0", BUTTERCREAM: "#F2E6B0",
  "CANARY RED": "#E63A2E", TANGERINE: "#F28C28", "PETROL BLUE": "#1F6E7A", AQUAMARINE: "#66CDBB",
  OCHER: "#C08A2E", OCHRE: "#C08A2E", TEAL: "#1F6E6E", "ANCIENT PINK": "#D9A9A0", IVORY: "#F5EFE0",
  YELLOW: "#F6D32D", AQUA: "#4FC3D6", GOLD: "#E0B93A", SAND: "#D8C7A0", PINK: "#F0A6C0",
  "FUTURE DARK": "#2B2F36", "DUSTY PURPLE": "#8E7C93", BRICK: "#9C4A38", "ASH GREY": "#B2B5B8", "ASH GRAY": "#B2B5B8",
  CORAL: "#F26D5B", VIOLET: "#7A4F9E", APPLE: "#6DBE45", "KLEIN BLUE": "#1F3A93", "PINK GUM": "#E8A0B0",
  "MEXICAN GREEN": "#3E7D3A", "WOLF GREY": "#8A9199", "SPRING GREEN": "#6FBF73", ALOE: "#9CB86A",
  "LEMON YELLOW": "#F4E04D", ORCHID: "#C97FB0", APRICOT: "#F2B47E", "LIGHT PURPLE": "#B9A0D6",
  "BROWN DARK": "#3F2A20", "CHARCOAL HEATHER": "#4A4E54", "DENIM HEATHER": "#5A6E8A",
  "DARK GREY MELANGE": "#6A6E72", "FUCSIA FLUOR": "#FF2E9A", "LIME FLUOR": "#C6FF2E", "ORANGE FLUOR": "#FF6A00", "GOLD FLUOR": "#FFD11A",
  // common non-JHK names
  "COLONY BLUE": "#4A7A9B", "DOVE GREY": "#9EA1A3", "DOVE GRAY": "#9EA1A3", "HEATHER GREY": "#B0B3B6",
  "HEATHER GRAY": "#B0B3B6", "TRUE ROYAL": "#1E4F9E", "OCEAN BLUE": "#1F6FA8", CHESTNUT: "#6B3A2A",
  GREEN: "#2E7D32", GREY: "#9AA0A6", GRAY: "#9AA0A6", CREAM: "#F2E6C8", CHARCOAL: "#36393D",
  MAROON: "#5C1A2B", TAN: "#C9A87A", STONE: "#CFC7B8", OLIVE: "#6B6A2E",
  "LIGHT GREY": "#C7CACC", "LIGHT GRAY": "#C7CACC", "MEDIUM GREY": "#8A9199", "MEDIUM GRAY": "#8A9199",
  "DARK GREY": "#4A4E54", "DARK GRAY": "#4A4E54", JEANS: "#5A6E8A", CAMOUFLAGE: "#5A6B3A",
  DESERT: "#C7A98B", "MAUVE LIGHT": "#C9A9B4", "MOCHA MOUSSE": "#A47864",
  ZINC: "#8A8D8F", COYOTE: "#81613C", "RED FLUOR": "#FE2B2B", TERRACOTTA: "#B5654A", BLUE: "#2A6BB0",
};

const KEYWORDS = [
  ["black", "#1A1A1A"], ["white", "#FFFFFF"], ["ivory", "#F5EFE0"], ["cream", "#F2E6C8"],
  ["azzure", "#6FA8DC"], ["azure", "#6FA8DC"], ["camouflage", "#5A6B3A"], ["camo", "#5A6B3A"],
  ["navy", "#1F2A44"], ["royal", "#1E56A0"], ["denim", "#4A6A8A"], ["jeans", "#5A6E8A"], ["petrol", "#1F6E7A"],
  ["sky", "#7FB6E0"], ["ice", "#CFE3EE"], ["aqua", "#4FC3D6"], ["turquoise", "#1BA6A6"],
  ["teal", "#1F6E6E"], ["blue", "#2A6BB0"], ["bottle", "#14452F"], ["forest", "#1F4D2E"],
  ["kelly", "#2E9B47"], ["mint", "#A8D8C0"], ["lime", "#9CCB3B"], ["olive", "#6B6A2E"],
  ["moss", "#6B7A3A"], ["army", "#5A5A3A"], ["green", "#2E7D32"], ["burgundy", "#6B1F2E"],
  ["maroon", "#5C1A2B"], ["cardinal", "#8C1D2C"], ["raspberry", "#A5264B"], ["warm red", "#E23B2E"],
  ["red", "#C8102E"], ["orange", "#F26522"], ["tangerine", "#F28C28"], ["peach", "#F6C1A0"],
  ["gold", "#E0B93A"], ["mustard", "#C99A2E"], ["ocher", "#C08A2E"], ["yellow", "#F6D32D"],
  ["fucsia", "#C42A82"], ["fuchsia", "#C42A82"], ["azalea", "#E7A6C4"], ["pink", "#F0A6C0"],
  ["purple", "#5E3A8C"], ["lavender", "#B9A7D6"], ["lavander", "#B9A7D6"], ["chocolate", "#3F2A20"],
  ["chestnut", "#6B3A2A"], ["brown", "#5A3A29"], ["tan", "#C9A87A"], ["sand", "#D8C7A0"],
  ["stone", "#CFC7B8"], ["khaki", "#8F8459"], ["graphite", "#3A3F44"], ["charcoal", "#36393D"],
  ["silver", "#C7CACC"], ["ash", "#C9CBCE"], ["heather", "#B0B3B6"], ["melange", "#9AA0A6"],
  ["grey", "#9AA0A6"], ["gray", "#9AA0A6"], ["zinc", "#7C8388"],
];

export const colorHex = (name) => {
  const k = key(name);
  if (COLOR_HEX[k]) return COLOR_HEX[k];
  const low = k.toLowerCase();
  for (const [kw, hex] of KEYWORDS) if (low.includes(kw)) return hex;
  return "#8A8F94";
};

// For two-tone names like "Azzure / Black" -> ["#6FA8DC", "#1A1A1A"]
export const colorHexes = (name) =>
  String(name || "")
    .split("/")
    .map((s) => s.trim())
    .filter(Boolean)
    .map(colorHex);

export const colorCode = (name) => COLOR_CODES[key(name)] || "";

export const colorName = (name) =>
  String(name || "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((w) => (w === "pfd" ? "PFD" : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(" ");

export const colorLabel = (name) => {
  const code = colorCode(name);
  const nm = colorName(name);
  if (!code || code.toUpperCase() === key(name)) return nm;
  return `${code} - ${nm}`;
};
